import { MutationTree } from 'vuex'
import { CacheState } from './types'
export const mutations: MutationTree<CacheState> = {

}
